import { LabelProps, RangeSlider, RangeSliderProps } from '@workspace/core-ts/components';
import { Field, Label, TextError } from '@workspace/core-ts/components';
import { ErrorMessage } from '@hookform/error-message';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { ReactNode } from 'react';
export interface FieldSliderProps<TFormValues extends Record<string, any> = any> extends RangeSliderProps, LabelProps {
    label?: string;
    name: Path<TFormValues> | string;
    validation?: RegisterOptions<FieldValues, string> | undefined;
    defaultValue?: number;
    required?: boolean;
    children?: ReactNode;
}

export function FieldSlider({ label, name, required = true, children, validation, defaultValue, ...props }: FieldSliderProps) {
    const methods = useFormContext();

    const handleChange = async (value: number) => {
        methods.setValue(name, value);
        await methods.trigger(name);
    };

    return (
        <Field data-name={name}>
            <Label required={required}>{label}</Label>
            <Controller
                control={methods.control}
                defaultValue={defaultValue}
                name={name}
                render={({ field }) => <RangeSlider setValue={handleChange} value={field.value} {...props} />}
                rules={{
                    required: {
                        value: required,
                        message: 'Ce champs est requis',
                    },
                    ...validation,
                }}
            />
            <ErrorMessage errors={methods.formState.errors} name={name} render={({ message }) => <TextError>{message}</TextError>} />
            {children}
        </Field>
    );
}
